import { onError } from "@apollo/client/link/error";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "globalErrorhandling/AppInsights";
import { getRecoilStore } from "recoil-toolkit";
import { v4 as uuidv4 } from "uuid";
import { toastStateAtom } from "components/Toast/toastState";
import translations from "translations";
// import { globalErrorUIState } from "../globalErrorhandling/globalErrorState";

const operationErrorWhiteList = [
  "getSorageAreaCoordinatesOnIds",
  "getDeviceIdsOnAssetMasterDatasItemName",
  "getDeviceIdsOnSensorMeasurementCurrentValuesByCoordinates",
];
export default onError(({ forward, operation, response = {}, networkError, ...error }) => {
  let severityLevel = SeverityLevel.Error;
  const id = uuidv4();

  // Handle authentication errors gracefully
  if (networkError && "statusCode" in networkError) {
    const statusCode = networkError.statusCode;
    if (statusCode === 401) {
      console.debug(`[Apollo] Unauthenticated (401) for operation: ${operation.operationName} - handled silently`);
      // 401 is handled by TokenExpirationHandler
      return;
    }
    if (statusCode === 403) {
      console.debug(`[Apollo] Forbidden (403) for operation: ${operation.operationName}`);
      getRecoilStore()
        .then((store) =>
          store.set(toastStateAtom, {
            open: true,
            message: translations.globals.popupMessages.notAuthorized,
            severity: "error",
          })
        )
        .catch(console.error);
      return;
    }
  }

  // Always log all errors to the console
  console.error("[GraphQL Error]", {
    operationName: operation.operationName,
    error,
    response,
    networkError,
    id,
  });

  if (
    operationErrorWhiteList.includes(operation.operationName) ||
    operation.operationName.startsWith("QueryBuilder_")
  ) {
    severityLevel = SeverityLevel.Warning;
  } else {
    if (process.env.NODE_ENV === "development") console.log({ operation, error });
  }

  appInsights.trackException({
    exception: {
      message: `gqlError ${operation.operationName}`,

      columnNumber: 0,
      lineNumber: 0,
      url: "http://" + id,
      error: new Error(id),
      evt: id,
    },

    properties: {
      trace: JSON.stringify(error, null, 2),
      ...operation,
      error,
    },
    severityLevel,
  });

  getRecoilStore()
    .then((store) => {
      // store.set(globalErrorUIState, [id]);
    })
    .catch(console.log);
  forward(operation);
});
